import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_task_assignment_grid_ComponentContextService } from './FootprintManager.task_assignment_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { LaborManagement_is_assigned_dd_singleComponent } from './LaborManagement.is_assigned_dd_single.component'
import { LaborManagement_assigned_task_operation_codes_dd_multiComponent } from './LaborManagement.assigned_task_operation_codes_dd_multi.component'
import { Inventory_task_statuses_dd_multiComponent } from './Inventory.task_statuses_dd_multi.component'
import { LaborManagement_assigned_users_dd_multiComponent } from './LaborManagement.assigned_users_dd_multi.component'


interface IFootprintManager_task_assignment_gridComponentEntity {
  Id?: number, ChainHead?: number, CreatedSysDateTime?: string, ExpectedPackagedAmount?: number, Priority?: number, Project?: { Id?: number, LookupCode?: string, Name?: string, OwnerId?: number }, ExpectedTargetShippingContainer?: { Id?: number, LookupCode?: string }, Lot?: { Id?: number, LookupCode?: string }, Material?: { Id?: number, LookupCode?: string }, ExpectedPackagedPack?: { Id?: number, Name?: string }, OperationCode?: { Id?: number, Name?: string }, Warehouse?: { Id?: number, Name?: string }, ExpectedTargetLocation?: { Id?: number, Name?: string }, ExpectedSourceLocation?: { Id?: number, Name?: string }, Status?: { Id?: number, Name?: string }, Order?: { Id?: number, LookupCode?: string }, PickSlip?: { Id?: number, Wave?: { Id?: number } }}

interface IFootprintManager_task_assignment_gridComponentInParams {
  warehouseIds?: number[], workClassIds?: number[], fromDate?: string, toDate?: string, projectId?: number, ownerId?: number}


class FootprintManager_task_assignment_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_task_assignment_gridComponent;
  entity: IFootprintManager_task_assignment_gridComponentEntity;

  vars: { taskAssignments?: { id?: number, userId?: string }[] } = { };


 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    task_id: null,
    operation_code_name: null,
    priority: null,
    status_name: null,
    assigned_user: null,
    task_created_on: null,
    project_code: null,
    order_code: null,
    wave: null,
    material_code: null,
    lot_code: null,
    packaging_name: null,
    packaged_amount: null,
    warehouse_name: null,
    source_location_name: null,
    target_location_name: null,
    target_shipping_container_code: null,
  }



  constructor(
    grid: FootprintManager_task_assignment_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_task_assignment_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.task_id = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.task_id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.operation_code_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.operation_code_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.priority = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.priority,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.status_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.status_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.assigned_user = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.assigned_user,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.task_created_on = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.task_created_on,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.project_code = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.project_code,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.order_code = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.order_code,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.wave = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.wave,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.material_code = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.material_code,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.lot_code = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.lot_code,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.packaging_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.packaging_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.packaged_amount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.packaged_amount,
      new TextModel(null, null,  'number', '0', null)
,
null
      );
    
    this.cells.warehouse_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.warehouse_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.source_location_name = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.source_location_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.target_location_name = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.target_location_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.target_shipping_container_code = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.target_shipping_container_code,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_task_assignment_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_task_assignment_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      warehouseIds:  $grid.inParams.warehouseIds ,
      workClassIds:  $grid.inParams.workClassIds ,
      fromDate:  $grid.inParams.fromDate ,
      toDate:  $grid.inParams.toDate ,
      fullTextSearch:  $grid.fullTextSearch ,
      isAssigned:  $grid.filters.task_is_assigned.control.value ,
      projectId:  $grid.inParams.projectId ,
      statusIds:  $grid.filters.status.control.value ,
      operationCodeIds:  $grid.filters.operation_code_ids.control.value ,
      ownerId:  $grid.inParams.ownerId ,
      userIds:  $grid.filters.assigned_user.control.value ,
    };
    const data = await this.$datasources.LaborManagement.ds_task_assignment_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_task_assignment_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.task_id.displayControl as TextModel).text = $row.entity.Id?.toString();
    (this.cells.operation_code_name.displayControl as TextModel).text = $row.entity.OperationCode?.Name;
    (this.cells.priority.displayControl as TextModel).text = $row.entity.Priority?.toString();
    (this.cells.status_name.displayControl as TextModel).text = $row.entity.Status?.Name;
    (this.cells.task_created_on.displayControl as TextModel).text = $row.entity.CreatedSysDateTime?.toString();
    (this.cells.project_code.displayControl as TextModel).text = $row.entity.Project?.LookupCode;
    (this.cells.order_code.displayControl as TextModel).text = $row.entity.Order?.LookupCode;
    (this.cells.wave.displayControl as TextModel).text = $utils.isDefined($row.entity.PickSlip?.Wave?.Id) ? $row.entity.PickSlip?.Wave?.Id.toString() : '';
    (this.cells.material_code.displayControl as TextModel).text = $row.entity.Material?.LookupCode;
    (this.cells.lot_code.displayControl as TextModel).text = $row.entity.Lot?.LookupCode;
    (this.cells.packaging_name.displayControl as TextModel).text = $row.entity.ExpectedPackagedPack?.Name;
    (this.cells.packaged_amount.displayControl as TextModel).text = $row.entity.ExpectedPackagedAmount?.toString();
    (this.cells.warehouse_name.displayControl as TextModel).text = $row.entity.Warehouse?.Name;
    (this.cells.source_location_name.displayControl as TextModel).text = $row.entity.ExpectedSourceLocation?.Name;
    (this.cells.target_location_name.displayControl as TextModel).text = $row.entity.ExpectedTargetLocation?.Name;
    (this.cells.target_shipping_container_code.displayControl as TextModel).text = $row.entity.ExpectedTargetShippingContainer?.LookupCode;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'task_id' : {
        this.on_task_id_clicked();
        break;
      }
      case 'order_code' : {
        this.on_order_clicked();
        break;
      }
      case 'wave' : {
        this.on_wave_clicked();
        break;
      }
      case 'source_location_name' : {
        this.on_source_location_clicked();
        break;
      }
      case 'target_location_name' : {
        this.on_target_location_clicked();
        break;
      }
      case 'target_shipping_container_code' : {
        this.on_container_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_task_id_clicked(event = null) {
    return this.on_task_id_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_task_id_clickedInternal(
    $row: FootprintManager_task_assignment_gridComponentRowModel,
  $grid: FootprintManager_task_assignment_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_task_assignment_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  let result = await $shell.FootprintManager.opentask_assignment_editorDialog({
      taskId: $row.entity.Id
  }, 'flyout', EModalSize.Large);
  
  if (result.isConfirmed) {
      await $row.refresh_row();
  
      if ($row.cells.priority.displayControl.text !== ($row.entity.Priority ?? '').toString()) {
          $grid.refresh();
      }
      else if ($utils.isDefined($row.entity.Priority) && $grid.headers.priority.hidden) {
          $grid.headers.priority.hidden = false;
      }
  }
  }
  refresh_row(event = null) {
    return this.refresh_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async refresh_rowInternal(
    $row: FootprintManager_task_assignment_gridComponentRowModel,
  $grid: FootprintManager_task_assignment_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_task_assignment_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $row.refresh();
  
  let task = (await $datasources.LaborManagement.ds_get_tasks_by_taskIds.get({ taskIds: [$row.entity.Id] })).result[0];
  
  // Currently assigned users
  task.TaskAssignments = task.TaskAssignments?.filter(ta => ta?.StatusId === 1 || ta?.StatusId === 2);
  let users = (await $datasources.LaborManagement.ds_get_users_info.getByKeys({ $keys: task.TaskAssignments.map(ta => ta.UserId) })).result;
  
  /**** SET CELL VALUES ****/
  // Assigned user
  $row.cells.assigned_user.displayControl.text = '';
  if ($utils.isDefined(task.TaskAssignments)) {
      $row.cells.assigned_user.displayControl.text = task.TaskAssignments.map(ta => users.find(u => u.id === ta.UserId)?.displayName ?? ta.UserId).join(', ');
  
      $row.vars.taskAssignments = task.TaskAssignments.map(ta => ({ id: ta.Id, userId: ta.UserId }));
  }
  
  for (let key in $row.cells) {
      $row.cells[key].styles.reset();
  }
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootprintManager_task_assignment_gridComponentRowModel,
  $grid: FootprintManager_task_assignment_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_task_assignment_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  $row.cells.task_created_on.displayControl.text = $utils.date.format($row.entity.CreatedSysDateTime, `${$settings.FootprintManager.DateFormat}, ${$settings.FootprintManager.TimeFormat.trim().toUpperCase() === '12 HOUR' ? 'LT' : 'H:MM'}`);
  }
  on_wave_clicked(event = null) {
    return this.on_wave_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_wave_clickedInternal(
    $row: FootprintManager_task_assignment_gridComponentRowModel,
  $grid: FootprintManager_task_assignment_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_task_assignment_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  let waveid = parseInt($row.cells.wave.displayControl.text)
  
  if (!isNaN(waveid)) { 
      $shell.FootprintManager.opensingle_wave_hub({
          waveId: waveid
      })
  }
  }
  on_order_clicked(event = null) {
    return this.on_order_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_order_clickedInternal(
    $row: FootprintManager_task_assignment_gridComponentRowModel,
  $grid: FootprintManager_task_assignment_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_task_assignment_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // Check order class type
  if ($utils.isDefined($row.entity?.Order?.Id)) {
      if (!isNaN($row.entity?.Order?.Id)) {
          const order = (await $datasources.SalesOrders.ds_get_order_by_orderId.get({ orderId: $row.entity.Order.Id })).result;
  
          if ($utils.isDefined(order)) {
              const orderClassTypeId = order.OrderClass.OrderClassTypeId;
              if (orderClassTypeId == 5) {
                  $shell.FootprintManager.opensales_order_editor({ orderId: order.Id });
              }
              else {
                  throw new Error('Editor for selected order class type under development!')
              }
          }
      }
  }
  
  
  }
  on_container_clicked(event = null) {
    return this.on_container_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_container_clickedInternal(
    $row: FootprintManager_task_assignment_gridComponentRowModel,
  $grid: FootprintManager_task_assignment_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_task_assignment_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  let shippingContainer: number = $row.entity?.ExpectedTargetShippingContainer?.Id
  
  if ($utils.isDefined(shippingContainer)) {
      if (!isNaN(shippingContainer)) {
          $shell.FootprintManager.openshipping_container_editor({ shippingContainerId: shippingContainer });
      }
  }
  
  
  
  }
  on_source_location_clicked(event = null) {
    return this.on_source_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_source_location_clickedInternal(
    $row: FootprintManager_task_assignment_gridComponentRowModel,
  $grid: FootprintManager_task_assignment_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_task_assignment_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  let expectedLocation: number = $row.entity?.ExpectedSourceLocation?.Id
  
  if ($utils.isDefined(expectedLocation)) {
      if (!isNaN(expectedLocation)) {
          $shell.FootprintManager.opensingle_location_hub({ locationId: expectedLocation });
      }
  }
  
  }
  on_target_location_clicked(event = null) {
    return this.on_target_location_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_target_location_clickedInternal(
    $row: FootprintManager_task_assignment_gridComponentRowModel,
  $grid: FootprintManager_task_assignment_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_task_assignment_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  let targetLocation: number = $row.entity?.ExpectedTargetLocation?.Id
  
  if ($utils.isDefined(targetLocation)) {
      if (!isNaN(targetLocation)) {
          $shell.FootprintManager.opensingle_location_hub({ locationId: targetLocation });
      }
  }
  
  
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => LaborManagement_is_assigned_dd_singleComponent),
    forwardRef(() => LaborManagement_assigned_task_operation_codes_dd_multiComponent),
    forwardRef(() => Inventory_task_statuses_dd_multiComponent),
    forwardRef(() => LaborManagement_assigned_users_dd_multiComponent),
  ],
  selector: 'FootprintManager-task_assignment_grid',
  templateUrl: './FootprintManager.task_assignment_grid.component.html'
})
export class FootprintManager_task_assignment_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_task_assignment_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_task_assignment_gridComponentInParams = { warehouseIds: [], workClassIds: [], fromDate: null, toDate: null, projectId: null, ownerId: null };


  //#region Variables
  vars: { unavailableOperationCodes?: number[] } = { };
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     task_id: new GridHeaderModel(new HeaderStyles(null, null), 'task_id', 'Task', false, false, null, false),       operation_code_name: new GridHeaderModel(new HeaderStyles(null, null), 'operation_code_name', 'Operation', false, false, null, false),       priority: new GridHeaderModel(new HeaderStyles(null, null), 'priority', 'Priority', false, false, null, false),       status_name: new GridHeaderModel(new HeaderStyles(null, null), 'status_name', 'Status', false, false, null, false),       assigned_user: new GridHeaderModel(new HeaderStyles(null, null), 'assigned_user', 'Assigned user', false, false, null, false),       task_created_on: new GridHeaderModel(new HeaderStyles(null, null), 'task_created_on', 'Created on', false, false, null, false),       project_code: new GridHeaderModel(new HeaderStyles(null, null), 'project_code', 'Project', false, false, null, false),       order_code: new GridHeaderModel(new HeaderStyles(null, null), 'order_code', 'Order', false, false, null, false),       wave: new GridHeaderModel(new HeaderStyles(null, null), 'wave', 'Wave', false, false, null, false),       material_code: new GridHeaderModel(new HeaderStyles(null, null), 'material_code', 'Material', false, false, null, false),       lot_code: new GridHeaderModel(new HeaderStyles(null, null), 'lot_code', 'Lot', false, false, null, false),       packaging_name: new GridHeaderModel(new HeaderStyles(null, null), 'packaging_name', 'Packaging', false, false, null, false),       packaged_amount: new GridHeaderModel(new HeaderStyles(null, null), 'packaged_amount', 'Packaged amount', false, false, null, false),       warehouse_name: new GridHeaderModel(new HeaderStyles(null, null), 'warehouse_name', 'Warehouse', false, false, null, false),       source_location_name: new GridHeaderModel(new HeaderStyles(null, null), 'source_location_name', 'Source location', false, false, null, false),       target_location_name: new GridHeaderModel(new HeaderStyles(null, null), 'target_location_name', 'Target location', false, false, null, false),       target_shipping_container_code: new GridHeaderModel(new HeaderStyles(null, null), 'target_shipping_container_code', 'Target container', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_task_assignment_gridComponentRowModel[] = [];

  @Input('warehouseIds') set $inParams_warehouseIds(value: any) {
    this.inParams['warehouseIds'] = value;
  }
  get $inParams_warehouseIds(): any {
    return this.inParams['warehouseIds'] ;
  }
  @Input('workClassIds') set $inParams_workClassIds(value: any) {
    this.inParams['workClassIds'] = value;
  }
  get $inParams_workClassIds(): any {
    return this.inParams['workClassIds'] ;
  }
  @Input('fromDate') set $inParams_fromDate(value: any) {
    this.inParams['fromDate'] = value;
  }
  get $inParams_fromDate(): any {
    return this.inParams['fromDate'] ;
  }
  @Input('toDate') set $inParams_toDate(value: any) {
    this.inParams['toDate'] = value;
  }
  get $inParams_toDate(): any {
    return this.inParams['toDate'] ;
  }
  @Input('projectId') set $inParams_projectId(value: any) {
    this.inParams['projectId'] = value;
  }
  get $inParams_projectId(): any {
    return this.inParams['projectId'] ;
  }
  @Input('ownerId') set $inParams_ownerId(value: any) {
    this.inParams['ownerId'] = value;
  }
  get $inParams_ownerId(): any {
    return this.inParams['ownerId'] ;
  }

  topToolbar = {
      assign_user: new ToolModel(new ButtonModel('assign_user', new ButtonStyles(null, null), false, false, false, 'Assign user', 'icon-ic_fluent_person_add_20_regular', null)
    , false),
      unassign: new ToolModel(new ButtonModel('unassign', new ButtonStyles(null, null), false, false, false, 'Unassign', 'icon-ic_fluent_person_prohibited_20_regular', null)
    , false),
      separator2: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      refresh: new ToolModel(new ButtonModel('refresh', new ButtonStyles(null, null), false, false, false, ' ', 'icon-ic_fluent_arrow_clockwise_20_regular', () => { const $utils = this.$utils; const $grid = this; return 'Refresh'; })
    , false)
  };

  bottomToolbar = {
  };

  formGroup: FormGroup = new FormGroup({
    task_is_assigned: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    operation_code_ids: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    status: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    assigned_user: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });

  filters = {
    task_is_assigned: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['task_is_assigned'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Assignment state', false, false),
    operation_code_ids: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['operation_code_ids'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Operation code', false, false),
    status: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['status'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Status', false, false),
    assigned_user: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['assigned_user'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false,
  false,
  '', null)
, new ControlContainerStyles(null, null), 'Assigned user', false, false),
  }

  //#region filters inParams
  cacheValueFor_$fields_operation_code_ids_selector_inParams_warehouseIds: number[];
  get $fields_operation_code_ids_selector_inParams_warehouseIds(): number[] {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.warehouseIds;
    
    if(!isEqual(this.cacheValueFor_$fields_operation_code_ids_selector_inParams_warehouseIds, expr)) {
      this.cacheValueFor_$fields_operation_code_ids_selector_inParams_warehouseIds = expr;
    }
    return this.cacheValueFor_$fields_operation_code_ids_selector_inParams_warehouseIds;
  }

  cacheValueFor_$fields_operation_code_ids_selector_inParams_workClassIds: number[];
  get $fields_operation_code_ids_selector_inParams_workClassIds(): number[] {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.workClassIds;
    
    if(!isEqual(this.cacheValueFor_$fields_operation_code_ids_selector_inParams_workClassIds, expr)) {
      this.cacheValueFor_$fields_operation_code_ids_selector_inParams_workClassIds = expr;
    }
    return this.cacheValueFor_$fields_operation_code_ids_selector_inParams_workClassIds;
  }

  get $fields_operation_code_ids_selector_inParams_ownerId(): number {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.ownerId;
    
    return expr;
  }

  get $fields_operation_code_ids_selector_inParams_projectId(): number {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.projectId;
    
    return expr;
  }

  get $fields_operation_code_ids_selector_inParams_fromDate(): string {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.fromDate;
    
    return expr;
  }

  get $fields_operation_code_ids_selector_inParams_toDate(): string {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.inParams.toDate;
    
    return expr;
  }

  cacheValueFor_$fields_assigned_user_selector_inParams_statusIds: number[];
  get $fields_assigned_user_selector_inParams_statusIds(): number[] {
    const $grid = this;
    const $utils = this.$utils;
    const expr = $grid.filters.status.control.value;
    
    if(!isEqual(this.cacheValueFor_$fields_assigned_user_selector_inParams_statusIds, expr)) {
      this.cacheValueFor_$fields_assigned_user_selector_inParams_statusIds = expr;
    }
    return this.cacheValueFor_$fields_assigned_user_selector_inParams_statusIds;
  }

  //#endregion filters inParams


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_task_assignment_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Task assignment';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 100;

    (this.filters.status.control as SelectBoxModel).reset([1,4]);

    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

    this.formGroup.valueChanges.pipe(takeUntil(this.$unsubscribe$)).subscribe(value => {
      this.reload();
    });
  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    if(!this.formGroup.valid) {
      return;
    }
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      warehouseIds:  $grid.inParams.warehouseIds ,
      workClassIds:  $grid.inParams.workClassIds ,
      fromDate:  $grid.inParams.fromDate ,
      toDate:  $grid.inParams.toDate ,
      fullTextSearch:  $grid.fullTextSearch ,
      isAssigned:  $grid.filters.task_is_assigned.control.value ,
      projectId:  $grid.inParams.projectId ,
      statusIds:  $grid.filters.status.control.value ,
      operationCodeIds:  $grid.filters.operation_code_ids.control.value ,
      ownerId:  $grid.inParams.ownerId ,
      userIds:  $grid.filters.assigned_user.control.value ,
    };
    try {
      const data = await this.$datasources.LaborManagement.ds_task_assignment_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_task_assignment_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_task_assignment_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_grid_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_task_assignment_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_grid_data_loaded(event = null) {
    return this.on_grid_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_grid_data_loadedInternal(
    $grid: FootprintManager_task_assignment_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_task_assignment_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  await setExpandedTaskFields();
  
  hideUnusedColumns();
  
  
  
  /**************************************
   * FUNCTIONS
  ***************************************/
  async function setExpandedTaskFields() {
      let tasks = (await $datasources.LaborManagement.ds_get_tasks_by_taskIds.get({ taskIds: $grid.rows.map(row => row.entity.Id) })).result;
      let userIds = tasks.reduce((output, task) => output = output.concat(task.TaskAssignments.map(ta => ta.UserId)), []);
  
      // Currently assigned users
      tasks.forEach(task => task.TaskAssignments = task.TaskAssignments?.filter(ta => ta?.StatusId === 1 || ta?.StatusId === 2));
      let users = (await $datasources.LaborManagement.ds_get_users_info.getByKeys({ $keys: userIds })).result;
  
      for (let row of $grid.rows) {
          let task = tasks.find(t => t.Id === row.entity.Id);
  
          /**** SET CELL VALUES ****/
          // Assigned user
          if ($utils.isDefined(task.TaskAssignments)) {
              row.cells.assigned_user.displayControl.text = task.TaskAssignments.map(ta => users.find(u => u.id === ta.UserId)?.displayName ?? ta.UserId).join(', ');
  
              row.vars.taskAssignments = task.TaskAssignments.map(ta => ({ id: ta.Id, userId: ta.UserId }));
          }
      }
  }
  
  function hideUnusedColumns() {
      for (let key in $grid.headers) {
          if (key !== 'assigned_user' && !$grid.rows.find(row => $utils.isDefinedTrimmed(row.cells[key].displayControl.text))) {
              $grid.headers[key].hidden = true;
          }
          else {
              $grid.headers[key].hidden = false;
          }
      }
  }
  
  }
  on_assign_user_clicked(event = null) {
    return this.on_assign_user_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_assign_user_clickedInternal(
    $grid: FootprintManager_task_assignment_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_task_assignment_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($grid.selectedRows.length > 0) {
      let user = (await $shell.FootprintManager.openselect_user_formDialog({ operationCodeIds: $grid.selectedRows.map(row => row.entity.OperationCode.Id) }, 'modal')).user;
  
      let failedTasks: { message: string, detail: string }[] = [];
  
      for (let row of $grid.selectedRows) {
          if ($utils.isDefined(user?.id)) {
              for (const key in row.cells) {
                  row.cells[key].styles.setPlannedClass();
              }
  
              let promise = $flows.LaborManagement.assign_user_to_task_flow({ taskId: row.entity.Id, userId: user.id });
              if (!$utils.isDefined(promises)) {
                  var promises = [promise];
              }
              else {
                  promises.push(promise);
              }
          }
  
          row.selected = false;
      }
  
      if ($utils.isDefined(promises)) {
          let rowRefreshThreshold = 10;
  
          if (promises.length > rowRefreshThreshold) {
              let results = (await Promise.all(promises));
  
              for (let result of results) {
                  if ($utils.isDefined(result.reasons)) {
                      failedTasks.push({ message: `Task ${result.reflectedTaskId}`, detail: (await $flows.Utilities.grammar_format_string_array_flow({ values: result.reasons })).formattedValue });
                  }
              };
  
              $grid.refresh();
          }
          else {
              for (let promise of promises) {
                  promise.then(async result => {
                      if ($utils.isDefined(result.reasons)) {
                          failedTasks.push({ message: `Task ${result.reflectedTaskId}`, detail: (await $flows.Utilities.grammar_format_string_array_flow({ values: result.reasons })).formattedValue });
                      }
  
                      let row = $grid.rows.find(row => row.entity.Id === result.reflectedTaskId);
                      row.refresh_row();
                  });
              }
  
  
          }
      }
      // If any tasks failed, inform user
      if ($utils.isDefined(failedTasks)) {
          let distinctReasons = [...new Set(failedTasks.map(t => t.detail))];
  
          if (distinctReasons.length > 1) {
              await $shell.FootprintManager.openErrorDialog('Failed to assign tasks', `The selected tasks were not able to be assigned to ${user.username}.`, null, 'Details', failedTasks);
          }
          else {
              await $shell.FootprintManager.openErrorDialog('Failed to assign tasks', `The selected tasks were not able to be assigned to ${user.username}.`, distinctReasons);
          }
      }
  }
  
  /******************************
   * FUNCTION
  *******************************/
  //async function assignTask
  
  
  }
  on_unassign_clicked(event = null) {
    return this.on_unassign_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_unassign_clickedInternal(
    $grid: FootprintManager_task_assignment_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_task_assignment_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($grid.selectedRows.length > 0) {
      let failedTasks: { message: string, detail: string }[] = [];
  
      for (let row of $grid.selectedRows) {
          if ($utils.isDefined(row.vars.taskAssignments)) {
              for (let key in row.cells) {
                  row.cells[key].styles.setPlannedClass();
              }
  
              let promise = $flows.LaborManagement.unassign_task_flow({ taskId: row.entity.Id, taskAssignmentIds: row.vars.taskAssignments.map(ta => ta.id) });
  
              if (!$utils.isDefined(promises)) {
                  var promises = [promise];
              }
              else {
                  promises.push(promise);
              }
          }
          row.selected = false;
      }
  
      if ($utils.isDefined(promises)) {
          let results = (await Promise.all(promises));
          let rowRefreshThreshold = 10;
  
          for (let result of results) {
              if ($utils.isDefined(result.reasons)) {
                  failedTasks.push({ message: `Task ${result.taskId}`, detail: (await $flows.Utilities.grammar_format_string_array_flow({ values: result.reasons })).formattedValue });
              }
              else if (results.length <= rowRefreshThreshold) {
                  $grid.rows.find(row => row.entity.Id === result.taskId).refresh_row();
              }
          };
  
          if (results.length > rowRefreshThreshold) {
              $grid.refresh();
          }
      }
  
      // If any tasks failed, inform user
      if ($utils.isDefined(failedTasks)) {
          let distinctReasons = [...new Set(failedTasks.map(t => t.detail))];
  
          if (distinctReasons.length > 1) {
              await $shell.LaborManagement.openErrorDialog('Failed to unassign tasks', `The selected tasks were not able to be unassigned.`, null, 'Details', failedTasks);
          }
          else {
              await $shell.LaborManagement.openErrorDialog('Failed to unassign tasks', `The selected tasks were not able to be unassigned.`, distinctReasons);
          }
      }
  }
  }
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: FootprintManager_task_assignment_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_task_assignment_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  if ($grid.selectedRows.length > 0) {
      $grid.topToolbar.assign_user.control.readOnly = false;
      $grid.topToolbar.unassign.control.readOnly = false;
  }
  else {
      $grid.topToolbar.assign_user.control.readOnly = true;
      $grid.topToolbar.unassign.control.readOnly = true;
  }
  }
  on_refresh(event = null) {
    return this.on_refreshInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_refreshInternal(
    $grid: FootprintManager_task_assignment_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_task_assignment_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $grid.refresh();
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
